import PropTypes from 'prop-types';
import { useRef } from 'react';
import { SnackbarProvider as NotistackProvider } from 'notistack';
import { IconButton } from '@mui/material'; 
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import GlobalStyles from "@mui/material/GlobalStyles";

SnackbarProvider.propTypes = {
  children: PropTypes.node,
};

export default function SnackbarProvider({ children })
{
  const notistackRef = useRef(null);

  const onClose = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <>
      <GlobalStyles
        styles={(theme) => ({
          '#root': {
            '.SnackbarContent-root': {
              width: '100%',
              padding: theme.spacing(1),
              margin: theme.spacing(0.25, 0),
              boxShadow: theme.customShadows.z8,
              borderRadius: theme.shape.borderRadius,
              color: theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[800],
              backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[900] : theme.palette.common.white,
              '&.SnackbarItem-variantSuccess, &.SnackbarItem-variantError, &.SnackbarItem-variantWarning, &.SnackbarItem-variantInfo':
              {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              },
              [theme.breakpoints.up('md')]: {
                minWidth: 240,
              },
            },
            '.SnackbarItem-message': {
              padding: '0 !important',
              fontWeight: theme.typography.fontWeightMedium,
            },
            '.SnackbarItem-action': {
              marginRight: 0,
              color: theme.palette.action.active,

              '& svg': {
                width: 20,
                height: 20,
              },
            },
          },
        })}
      />
      <NotistackProvider
        ref={notistackRef}
        maxSnack={10}
        autoHideDuration={3000}
        TransitionComponent={undefined}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        iconVariant={{
          info: <InfoIcon color="info" />,
          success: <CheckCircleIcon color="success" />,
          warning: <WarningIcon color="warning" />,
          error: <ErrorIcon color="error" />,
        }}
        action={(key) => (
          <IconButton size="small" onClick={onClose(key)} sx={{ p: 0.5 }}>
            <CloseIcon />
          </IconButton>
        )}
      >
        {children}
      </NotistackProvider>
    </>
  );
}